<template>
  <div class="modal vc_modal my_account_modal" :class="{ show: isShowModal }">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content my_account_modal_content p_0">
        <button type="button" class="btn-close" @click="closeModal()"></button>
        <div class="modal-body p_0">
          <h5
            class="common_subtitle pb_15 font_18p border-lightgray-bottom pt_15 pl_15"
          >
            {{ server_name }} details
          </h5>
          <div class="p_20">
            <div class="row">
              <div class="d_flex_start pt_10 pb_10">
                <h6 class="d_flex_start w-100 common_subtitle">Basic info</h6>
              </div>
              <div class="col-6">
                <div class="table_responsive w-100">
                  <table
                    class="common_table table table_bordered table-hover w-100 align-middle"
                  >
                    <tbody>
                      <tr>
                        <th class="border_top_none transparent_bg">Service</th>
                        <td>{{ modalData?.cloudService?.name }}</td>
                      </tr>
                      <tr>
                        <th class="transparent_bg">Server name</th>
                        <td>
                          {{ server_name }}
                          <span
                            class="ml_20"
                            v-if="
                              modalData.kt_platform == 'g' ||
                              modalData.proxmox_vm_id
                            "
                          >
                            <button
                              v-if="hasPermission('Update')"
                              type="button"
                              class="btn btn-outline-primary btn-sm"
                              title="Change server name"
                              @click.prevent="openEditModal()"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <th class="transparent_bg">Kt platform</th>
                        <td class="text-uppercase">
                          {{ modalData?.kt_platform }}
                        </td>
                      </tr>
                      <tr>
                        <th class="transparent_bg">Username</th>
                        <td class="fw-bolder">
                          <span
                            class="badge bg-info fs-6"
                            v-if="modalData?.kt_platform == 'd'"
                            >ubuntu</span
                          >
                          <span class="badge bg-info fs-6" v-else>root</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="transparent_bg">Password</th>
                        <td class="fw-bolder">
                          <span class="badge bg-info fs-6">{{
                            modalData?.kt_password
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="transparent_bg">Region</th>
                        <td>{{ modalData?.serverRegion?.name }}</td>
                      </tr>
                      <template v-if="modalData.kt_platform === 'd'">
                        <tr>
                          <th class="transparent_bg">OS</th>
                          <td>
                            {{
                              modalData?.serverDProductType?.catChildList
                                ?.display_name
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th class="transparent_bg">Specification</th>
                          <td>
                            {{
                              modalData?.serverDProductType?.name ??
                              modalData?.serverProductType
                                ?.service_offering_desc
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th class="transparent_bg">Kt tier</th>
                          <td>{{ modalData?.ktTier?.name }}</td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <th class="transparent_bg">OS</th>
                          <td>
                            {{ modalData?.serverProductType?.template_desc }}
                          </td>
                        </tr>
                        <tr>
                          <th class="transparent_bg">Specification</th>
                          <td>
                            {{
                              modalData?.serverProductType
                                ?.service_offering_desc
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th class="border_bottom_none transparent_bg">
                            Space
                          </th>
                          <td class="border_bottom_none">
                            {{
                              modalData?.serverProductType?.disk_offering_desc
                            }}
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-6">
                <div class="table_responsive w-100">
                  <table
                    class="common_table table table_bordered table-hover w-100 align-middle"
                  >
                    <tbody>
                      <tr>
                        <th class="transparent_bg">Status</th>
                        <td class="fw-bolder">
                          <span class="badge bg-info fs-6">{{
                            modalData?.status
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="border_top_none transparent_bg">
                          Private IP
                        </th>
                        <td>{{ modalData?.private_ip }}</td>
                      </tr>
                      <tr>
                        <th class="border_top_none transparent_bg">
                          Public IP
                        </th>
                        <td>{{ modalData?.public_ip }}</td>
                      </tr>
                      <tr>
                        <th class="transparent_bg">Display name</th>
                        <td>{{ host_name }}</td>
                      </tr>
                      <tr>
                        <th class="transparent_bg">Ssh key pair</th>
                        <td>{{ modalData?.sshKeypair?.name }}</td>
                      </tr>
                      <tr>
                        <th class="transparent_bg">Billing type</th>
                        <td>
                          {{ billing_type }}
                          <span
                            class="ml_20"
                            v-if="modalData.kt_platform == 'g'"
                          >
                            <button
                              v-if="hasPermission('Update')"
                              type="button"
                              class="btn btn-outline-primary btn-sm"
                              title="Change billing type"
                              @click.prevent="openBillingTypeModal()"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <th class="transparent_bg">Initiated at</th>
                        <td>{{ modalData?.initiated_at }}</td>
                      </tr>
                      <tr>
                        <th class="transparent_bg">Started at</th>
                        <td>{{ modalData?.started_at }}</td>
                      </tr>
                      <tr>
                        <th class="transparent_bg">Stopped at</th>
                        <td>{{ modalData?.stopped_at }}</td>
                      </tr>
                      <tr>
                        <th class="border_bottom_none transparent_bg">
                          Restarted at
                        </th>
                        <td class="border_bottom_none">
                          {{ modalData?.restarted_at }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row" v-if="modalData?.proxmox_vm_id">
              <hr />
              <div class="d_flex_start pt_10 pb_10">
                <h6 class="d_flex_btwn w-100 common_subtitle">Usage history</h6>
                <div class="d_flex_end w-50">
                  <select
                    v-model="chartType"
                    @change="filterChartData"
                    class="form-select"
                  >
                    <option value="hour|AVERAGE">Hour - Average</option>
                    <option value="hour|MAX">Hour - Maximum</option>
                    <option value="day|AVERAGE">Day - Average</option>
                    <option value="day|MAX">Day - Maximum</option>
                    <option value="week|AVERAGE">Week - Average</option>
                    <option value="week|MAX">Week - Maximum</option>
                    <option value="month|AVERAGE">Month - Average</option>
                    <option value="month|MAX">Month - Maximum</option>
                    <option value="year|AVERAGE">Year - Average</option>
                    <option value="year|MAX">Year - Maximum</option>
                  </select>
                </div>
              </div>
              <div class="col_6 pb_10 chart-container">
                <div v-if="isLoadingCpu" class="chart-loader">
                  <div class="spinner"></div>
                </div>
                <canvas v-show="!isLoadingCpu" id="rawCpuChart"></canvas>
              </div>
              <div class="col_6 pb_10 chart-container">
                <div v-if="isLoadingMemory" class="chart-loader">
                  <div class="spinner"></div>
                </div>
                <canvas v-show="!isLoadingMemory" id="rawMemoryChart"></canvas>
              </div>
              <div class="col_6 mt_20 chart-container">
                <div v-if="isLoadingNetwork" class="chart-loader">
                  <div class="spinner"></div>
                </div>
                <canvas
                  v-show="!isLoadingNetwork"
                  id="rawNetworkChart"
                ></canvas>
              </div>
              <div class="col_6 mt_20 chart-container">
                <div v-if="isLoadingDisk" class="chart-loader">
                  <div class="spinner"></div>
                </div>
                <canvas v-show="!isLoadingDisk" id="rawDiskChart"></canvas>
              </div>
            </div>
            <div class="row">
              <div class="d_flex_start pt_10 pb_10">
                <h6 class="d_flex_start w-100 common_subtitle">Disk info</h6>
              </div>
              <div class="col_12">
                <div class="table_responsive w-100">
                  <table
                    class="common_table table table_bordered table-hover w-100 align-middle"
                  >
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Region</th>
                        <th>Type</th>
                        <th>Product</th>
                        <th>Space</th>
                        <th>IOPS</th>
                        <th>Status</th>
                        <th>Billing type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(disk, diskIndex) in disks"
                        :key="'disk_' + diskIndex"
                      >
                        <td>{{ disk.name }}</td>
                        <td>{{ disk?.serverRegion?.name }}</td>
                        <td>{{ disk.disk_type }}</td>
                        <td>{{ disk.disk_product_type }}</td>
                        <td>{{ disk.space }}GB</td>
                        <td>{{ disk.iops }}</td>
                        <td>
                          <span
                            v-if="disk.status == 'processing'"
                            class="color_warning"
                            >Processing</span
                          >
                          <span
                            v-if="disk.status == 'running'"
                            class="color_success"
                            >Running</span
                          >
                          <span
                            v-if="disk.status == 'stopped'"
                            class="color_danger"
                            >Stopped</span
                          >
                        </td>
                        <td>{{ disk.billing_type }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ServerNameEditModal
      v-if="showEditModal"
      :showEditModal="showEditModal"
      :modalData="modalData"
      @closeEditModal="closeEditModal"
    />
    <ServerBillingTypeEditModal
      v-if="showBillingTypeModal"
      :showBillingTypeModal="showBillingTypeModal"
      :modalData="modalData"
      @closeBillingTypeModal="closeBillingTypeModal"
    />
  </div>
</template>

<script>
import ServerNameEditModal from './ServerNameEditModal.vue';
import ServerBillingTypeEditModal from './ServerBillingTypeEditModal.vue';
import { checkPermission } from '@/mixins/permissionsHelper';
import { mapGetters } from 'vuex';
import Chart from 'chart.js/auto';
import { nextTick } from 'vue';

export default {
  name: 'details-modal',
  components: { ServerNameEditModal, ServerBillingTypeEditModal },
  props: {
    isShowModal: {
      type: Boolean,
      required: true,
    },
    modalData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      disks: [],
      showEditModal: false,
      showBillingTypeModal: false,
      server_name: this.modalData?.server_name,
      host_name: this.modalData?.server_name,
      billing_type: this.modalData?.billing_type,
      chartType: 'hour|AVERAGE',
      rawCpuChart: null,
      rawMemoryChart: null,
      rawNetworkChart: null,
      rawDiskChart: null,
      isLoadingCpu: false,
      isLoadingMemory: false,
      isLoadingNetwork: false,
      isLoadingDisk: false,
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      permissions: 'serverPermissions/getServicePermission',
    }),
  },
  created() {
    this.loadDisks();
    if (this.modalData?.proxmox_vm_id) {
      // this.getCpuUsageChartData();
      this.getRawCpuChartData();
      this.getMemoryChart();
      this.getNetworkChart();
      this.getDiskChart();
    }
  },
  mounted() {
    if (this.modalData?.proxmox_vm_id) {
      this.chartRefreshInterval = setInterval(() => {
        this.getRawCpuChartData();
        this.getMemoryChart();
        this.getNetworkChart();
        this.getDiskChart();
      }, 2 * 60 * 1000);
    }
  },
  beforeUnmount() {
    if (this.chartRefreshInterval) {
      clearInterval(this.chartRefreshInterval);
    }
  },
  methods: {
    loadDisks() {
      this.axios
        .get('/get-server-cloud-disks/' + this.modalData?.id)
        .then(({ data }) => {
          this.disks = data.data;
        });
    },
    getCpuUsageChartData() {
      this.axios
        .get(`/proxmox/vm/${this.modalData?.proxmox_vm_id}/cpu`)
        .then((response) => {
          const labels = response.data.labels;
          const data = response.data.data.map((val) => val ?? 0); // replace nulls

          // Calculate dynamic max and step size
          const maxValue = Math.max(...data);
          const roundedMax = Math.ceil(maxValue + 1); // e.g., 5.3 → 6
          const stepSize = Math.ceil(roundedMax / 5); // divide into 5 steps

          nextTick(() => {
            const ctx = document.getElementById('cpuUsageChart');

            if (this.cpuUsageChart) {
              this.cpuUsageChart.destroy();
            }

            this.cpuUsageChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels: labels,
                datasets: [
                  {
                    label: 'CPU Usage (%)',
                    data: data,
                    fill: true,
                    borderWidth: 2,
                    borderColor: '#687715',
                    backgroundColor: 'rgba(104, 119, 21, 0.7)',
                    pointBackgroundColor: '#687715',
                    pointRadius: 4,
                    pointHoverBackgroundColor: '#687715',
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                  y: {
                    beginAtZero: true,
                    max: roundedMax,
                    ticks: {
                      stepSize: stepSize,
                      callback: (value) => value + '%',
                    },
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                  },
                },
                elements: {
                  line: {
                    tension: 0.15,
                  },
                },
              },
            });
          });
        });
    },
    filterChartData() {
      this.isLoadingCpu = true;
      this.isLoadingMemory = true;
      this.isLoadingNetwork = true;
      this.isLoadingDisk = true;
      setTimeout(() => {
        this.getRawCpuChartData();
        this.getMemoryChart();
        this.getNetworkChart();
        this.getDiskChart();
      }, 2000);
    },
    getRawCpuChartData() {
      const [timeframe, cf] = this.chartType.split('|');
      this.isLoadingCpu = true;

      this.axios
        .get(`/proxmox/vm/${this.modalData?.proxmox_vm_id}/cpu-raw`, {
          params: { timeframe, cf },
        })
        .then((response) => {
          const labels = response.data.labels.map((label) => label.split(' '));
          const data = response.data.data;

          nextTick(() => {
            const canvas = document.getElementById('rawCpuChart');
            const ctx = canvas.getContext('2d');

            const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
            gradient.addColorStop(0, 'rgba(104, 119, 21, 0.7)');
            gradient.addColorStop(1, 'rgba(104, 119, 21, 0.7)');

            if (this.rawCpuChart) {
              this.rawCpuChart.destroy();
            }

            this.rawCpuChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels: labels,
                datasets: [
                  {
                    label: `CPU Usage (%)`,
                    data: data,
                    borderColor: gradient,
                    backgroundColor: gradient,
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                  mode: 'index',
                  intersect: false,
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: (context) => `${context.raw}% at ${context.label}`,
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    suggestedMax: Math.ceil(Math.max(...data) + 1),
                    ticks: {
                      callback: (val) => `${val}%`,
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: true,
                      maxTicksLimit: 7,
                      maxRotation: 0,
                      minRotation: 0,
                    },
                  },
                },
              },
            });
            this.isLoadingCpu = false;
          });
        })
        .catch(() => {
          this.isLoadingCpu = false;
        });
    },
    getMemoryChart() {
      const [timeframe, cf] = this.chartType.split('|');
      this.isLoadingMemory = true;
      this.axios
        .get(`/proxmox/vm/${this.modalData?.proxmox_vm_id}/memory-raw`, {
          params: { timeframe, cf },
        })
        .then((response) => {
          const labels = response.data.labels.map((label) => label.split(' '));
          const data = response.data.data;
          const total = response.data.total;
          const unit = response.data.unit; // either 'MB' or 'GB'

          nextTick(() => {
            const canvas = document.getElementById('rawMemoryChart');
            const ctx = canvas.getContext('2d');

            const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
            gradient.addColorStop(0, 'rgba(52, 104, 108, 0.5)');
            gradient.addColorStop(1, 'rgba(52, 104, 108, 0.5)');

            if (this.rawMemoryChart) {
              this.rawMemoryChart.destroy();
            }

            this.rawMemoryChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels: labels,
                datasets: [
                  {
                    label: `Memory usage - Total`,
                    data: new Array(data.length).fill(total),
                    borderColor: 'rgba(104, 119, 21, 0.7)',
                    backgroundColor: 'rgba(104, 119, 21, 0.7)',
                    fill: true,
                    pointRadius: 0,
                    borderDash: [0, 0],
                  },
                  {
                    label: `Memory Usage - RAM Usage`,
                    data: data,
                    borderColor: gradient,
                    backgroundColor: gradient,
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                  mode: 'index',
                  intersect: false,
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: (context) =>
                        `${context.dataset.label}: ${context.raw} ${unit}`,
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    suggestedMax: Math.ceil(Math.max(...data, total) + 1),
                    ticks: {
                      callback: (val) => `${val} ${unit}`,
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: true,
                      maxTicksLimit: 7,
                      maxRotation: 0,
                      minRotation: 0,
                    },
                  },
                },
              },
            });
            this.isLoadingMemory = false;
          });
        })
        .catch(() => {
          this.isLoadingMemory = false;
        });
    },
    getNetworkChart() {
      const [timeframe, cf] = this.chartType.split('|');
      const formatNumber = this.formatNumber; // 👈 Fix here
      this.isLoadingNetwork = true;
      this.axios
        .get(`/proxmox/vm/${this.modalData?.proxmox_vm_id}/network-raw`, {
          params: { timeframe, cf },
        })
        .then((response) => {
          const labels = response.data.labels.map((label) => label.split(' '));
          const netin = response.data.netin;
          const netout = response.data.netout;

          const maxValue = Math.max(...netin, ...netout);
          const paddedMax = Math.ceil(maxValue * 1.1);

          nextTick(() => {
            const canvas = document.getElementById('rawNetworkChart');
            if (!canvas) return;

            const ctx = canvas.getContext('2d');
            const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
            gradient.addColorStop(0, 'rgba(52, 104, 108, 0.5)');
            gradient.addColorStop(1, 'rgba(52, 104, 108, 0.5)');

            if (this.rawNetworkChart) {
              this.rawNetworkChart.destroy();
            }

            this.rawNetworkChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels,
                datasets: [
                  {
                    label: `Network traffic - netin`,
                    data: netin,
                    borderColor: gradient,
                    backgroundColor: gradient,
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                  {
                    label: `Network traffic - netout`,
                    data: netout,
                    borderColor: 'rgba(104, 119, 21, 0.7)',
                    backgroundColor: 'rgba(104, 119, 21, 0.7)',
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                  mode: 'index',
                  intersect: false,
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: function (context) {
                        return `${context.dataset.label}: ${formatNumber(
                          context.raw
                        )}`;
                      },
                    },
                  },
                },
                scales: {
                  y: {
                    suggestedMax: paddedMax,
                    ticks: {
                      callback: (value) => formatNumber(value),
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: true,
                      maxTicksLimit: 7,
                      maxRotation: 0,
                      minRotation: 0,
                    },
                  },
                },
              },
            });
            this.isLoadingNetwork = false;
          });
        })
        .catch(() => {
          this.isLoadingNetwork = false;
        });
    },
    getDiskChart() {
      const [timeframe, cf] = this.chartType.split('|');
      const formatNumber = this.formatNumber;
      this.isLoadingDisk = true;
      this.axios
        .get(`/proxmox/vm/${this.modalData?.proxmox_vm_id}/disk-raw`, {
          params: { timeframe, cf },
        })
        .then((response) => {
          const labels = response.data.labels.map((label) => label.split(' '));
          const diskRead = response.data.diskread;
          const diskWrite = response.data.diskwrite;

          // 🔸 Add headroom above max value
          const maxValue = Math.max(...diskRead, ...diskWrite);
          const paddedMax = Math.ceil(maxValue * 1.1);

          nextTick(() => {
            const canvas = document.getElementById('rawDiskChart');
            if (!canvas) return;

            const ctx = canvas.getContext('2d');
            const gradientRead = ctx.createLinearGradient(
              0,
              0,
              0,
              canvas.height
            );
            gradientRead.addColorStop(0, 'rgba(52, 104, 108, 0.5)');
            gradientRead.addColorStop(1, 'rgba(52, 104, 108, 0.5)');

            const gradientWrite = ctx.createLinearGradient(
              0,
              0,
              0,
              canvas.height
            );
            gradientWrite.addColorStop(0, 'rgba(104, 119, 21, 0.7)');
            gradientWrite.addColorStop(1, 'rgba(104, 119, 21, 0.7)');

            if (this.rawDiskChart) {
              this.rawDiskChart.destroy();
            }

            this.rawDiskChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels,
                datasets: [
                  {
                    label: `Disk IO - diskread`,
                    data: diskRead,
                    borderColor: gradientRead,
                    backgroundColor: gradientRead,
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                  {
                    label: `Disk IO - diskwrite`,
                    data: diskWrite,
                    borderColor: gradientWrite,
                    backgroundColor: gradientWrite,
                    fill: true,
                    pointRadius: 0,
                    borderWidth: 1.5,
                  },
                ],
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                  mode: 'index',
                  intersect: false,
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: function (context) {
                        return `${context.dataset.label}: ${formatNumber(
                          context.raw
                        )}`;
                      },
                    },
                  },
                },
                scales: {
                  y: {
                    suggestedMax: paddedMax,
                    ticks: {
                      callback: (value) => formatNumber(value),
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: true,
                      maxTicksLimit: 7,
                      maxRotation: 0,
                      minRotation: 0,
                    },
                  },
                },
              },
            });
            this.isLoadingDisk = false;
          });
        })
        .catch(() => {
          this.isLoadingDisk = false;
        });
    },
    formatNumber(n) {
      if (n < 1000) return n.toString();
      const units = ['K', 'M', 'B', 'T'];
      const order = Math.floor(Math.log10(n) / 3);
      const unitname = units[order - 1];
      const num = n / Math.pow(1000, order);
      return `${num.toFixed(1)}${unitname}`;
    },
    openEditModal() {
      this.showEditModal = true;
      this.editModalData = this.modalData;
    },
    closeEditModal(value = null) {
      this.server_name = value;
      this.host_name = value;
      this.showEditModal = false;
    },
    openBillingTypeModal() {
      this.showBillingTypeModal = true;
      this.editModalData = this.modalData;
    },
    closeBillingTypeModal(value = null) {
      this.billing_type = value;
      this.showBillingTypeModal = false;
    },
    closeModal() {
      this.$emit('closeModal');
    },
    hasPermission(action) {
      let entity = this.permissions?.cloud_sub_service?.length
        ? this.permissions?.cloud_sub_service[0]
        : null;
      return checkPermission(this.permissions, entity, action);
    },
  },
};
</script>
<style scoped>
.modal {
  background-color: rgb(0 0 0 / 15%);
}

.chart-loader {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.chart-loader .spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #ccc;
  border-top-color: #3e8e41;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.chart-container {
  position: relative;
  height: 250px;
  overflow: hidden;
}

.chart-container canvas {
  height: 100% !important;
  width: 100% !important;
}
</style>
